import moment from 'moment'


export default class State {

  static evalCondition (condition, values, v, qid) {
    /*eslint no-unused-vars: "off"*/
    /*eslint camelcase: "off"*/

    let mfrancs_lte = function (m, c) {
      let date = moment(m, 'YYYY-MM-DD')
      let diff = moment().diff(date, 'months')
      return diff + 1 <= c
    }

    let jfrancs_lte = function (m, c) {
      let date = moment(m, 'YYYY-MM-DD')
      let diff = moment().diff(date, 'days')
      return diff + 1 <= c
    }

    let isFrancophone = function (countryId) {
      return countryId === 1 || countryId === 3 || countryId === 5 // TODO set right country
    }

    let isFrenchSpeaking = function (countryId) {
      return countryId === 6 // TODO set right country
    }


    /*eslint no-eval: "off"*/
    try {
      return eval(condition)
    } catch (err) {
      console.error('Failure on (question ' + qid + ') condition eval: ' + condition + '\nv: ' + JSON.stringify(v) + '\nError: ', err)
    }
    return false

  }
}




// WEBPACK FOOTER //
// ./src/model/Condition.js